import { put, call, take, fork } from 'redux-saga/effects'
import { deleteService } from '../../api/authentication'
import { authenticationDeleteSuccess } from '../../reducers/authentication/action'
import { AUTHENTICATION_DELETE } from '../../reducers/authentication/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'
import { remove as removeCookie } from 'es-cookie'

/**
 *
 * @param {*} payload
 */
function* deleteSagaFlow(payload) {
  try {
    yield call(deleteService)

    yield put(operationSuccess())
    yield put(authenticationDeleteSuccess())
    removeCookie('token')
    window.location.href = '/'
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* deleteSagaWatcher() {
  while (true) {
    const action = yield take(AUTHENTICATION_DELETE)
    const { payload } = action

    yield fork(generalSaga, deleteSagaFlow, payload)
  }
}
